// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CusModal_wrapper__1G9fz"};